import { makeVar } from "@apollo/client";

export const isUserAlreadyRedirectedToAffiliateViewVar = makeVar(false);
